import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SettingsStickySaveFooter from 'settings-ui-lib/components/SettingsStickySaveFooter';
import { saveModifiedSettings } from '../actions/SettingsActions';
import { resetStagedSettings } from '../reducers/stagedSettingsReducer';
import { modifiedSettingsCountSelector } from '../selectors/SettingsSelectors';
import { rethrowError } from 'UIComponents/core/PromiseHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TasksSettingsSaveFooter() {
  const dispatch = useDispatch();
  const stagedChangesCount = useSelector(modifiedSettingsCountSelector);
  const onCancel = useCallback(() => dispatch(resetStagedSettings()), [dispatch]);
  const onSave = useCallback(() => {
    dispatch(saveModifiedSettings()).catch(e => rethrowError(e));
  }, [dispatch]);
  return /*#__PURE__*/_jsx(SettingsStickySaveFooter, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsuilib.pendingChanges",
      options: {
        count: stagedChangesCount
      }
    }),
    shouldRender: stagedChangesCount > 0,
    onCancel: onCancel,
    onSave: onSave
  });
}